import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllLiveVideos(payload) {
  try {
    yield put(actions.liveVideosLoading(true));
    const result = yield call(api.getAllLiveVideos, payload);
    yield put(actions.getAllLiveVideosSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllLiveVideosFail());
  } finally {
    yield put(actions.liveVideosLoading(false));
  }
}

function* getLiveVideoById(payload) {
  try {
    yield put(actions.liveVideosLoading(true));
    const result = yield call(api.getLiveVideoById, payload);
    yield put(actions.getLiveVideoByIdSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getLiveVideoByIdFail());
  } finally {
    yield put(actions.liveVideosLoading(false));
  }
}

function* createLiveVideo({ payload, action }) {
  try {
    console.log("createLiveVideo saga called with payload:", payload);
    console.log("createLiveVideo saga called with action:", action);
    yield put(actions.liveVideosLoading(true));
    const result = yield call(api.createLiveVideo, payload);
    console.log("API result:", result);
    yield put(
      actions.createLiveVideoSuccess({
        data: result.data.data,
      })
    );
    action && action();
    toast.success("Live Video Created Successfully");
  } catch (error) {
    console.error("createLiveVideo error:", error);
    yield put(actions.createLiveVideoFail());
  } finally {
    yield put(actions.liveVideosLoading(false));
  }
}

function* updateLiveVideo({ payload }) {
  try {
    yield put(actions.liveVideosLoading(true));
    const result = yield call(api.updateLiveVideo, payload.id, payload.data);
    yield put(
      actions.updateLiveVideoSuccess({
        data: result.data.data,
      })
    );
    toast.success("Live Video Updated Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.updateLiveVideoFail());
  } finally {
    yield put(actions.liveVideosLoading(false));
  }
}

function* deleteLiveVideo({ payload }) {
  try {
    yield put(actions.liveVideosLoading(true));
    yield call(api.deleteLiveVideo, payload.id);
    yield put(actions.deleteLiveVideoSuccess(payload.id));
    toast.success("Live Video Deleted Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.deleteLiveVideoFail());
  } finally {
    yield put(actions.liveVideosLoading(false));
  }
}

function* getLiveVideosByCourse(payload) {
  try {
    yield put(actions.liveVideosLoading(true));
    const result = yield call(api.getLiveVideosByCourse, payload);
    yield put(actions.getLiveVideosByCourseSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getLiveVideosByCourseFail());
  } finally {
    yield put(actions.liveVideosLoading(false));
  }
}

function* getLiveVideosByTeacher(payload) {
  try {
    yield put(actions.liveVideosLoading(true));
    const result = yield call(api.getLiveVideosByTeacher, payload);
    yield put(actions.getLiveVideosByTeacherSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getLiveVideosByTeacherFail());
  } finally {
    yield put(actions.liveVideosLoading(false));
  }
}

export default function* SuperadminLiveVideosSaga() {
  yield takeLatest(Types.GET_SUPERADMIN_LIVE_VIDEOS_REQUEST, getAllLiveVideos);
  yield takeLatest(Types.GET_SUPERADMIN_LIVE_VIDEO_BY_ID_REQUEST, getLiveVideoById);
  yield takeLatest(Types.CREATE_SUPERADMIN_LIVE_VIDEO_REQUEST, createLiveVideo);
  yield takeLatest(Types.UPDATE_SUPERADMIN_LIVE_VIDEO_REQUEST, updateLiveVideo);
  yield takeLatest(Types.DELETE_SUPERADMIN_LIVE_VIDEO_REQUEST, deleteLiveVideo);
  yield takeLatest(Types.GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_REQUEST, getLiveVideosByCourse);
  yield takeLatest(Types.GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_REQUEST, getLiveVideosByTeacher);
} 